module.exports = __webpack_public_path__ + "static/Lato-Black-77d353744697c77955f9bacc7f3ed90a.ttf";